import React from "react";

const IDownload = ({
  color = "#252526",
  width = "18",
  height = "18",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M6.35229 13.1028C6.13262 13.3224 6.13262 13.6785 6.35229 13.8982L8.60229 16.1482C8.82196 16.3678 9.17804 16.3678 9.39771 16.1482L11.6477 13.8982C11.8674 13.6785 11.8674 13.3224 11.6477 13.1028C11.428 12.8831 11.072 12.8831 10.8523 13.1028L9 14.9551L7.1477 13.1028C6.92803 12.8831 6.57196 12.8831 6.35229 13.1028Z"
        fill={color}
      />
      <path
        d="M8.4375 15.0005H9.5625V12.0005C9.5625 11.6898 9.31066 11.438 9 11.438C8.68934 11.438 8.4375 11.6898 8.4375 12.0005V15.0005Z"
        fill={color}
      />
      <path
        d="M1.6875 8.405C1.68763 7.04152 2.71453 5.91804 4.03711 5.76535L4.01147 5.17649C3.84315 1.41136 9.00014 0.578707 10.2268 3.7966C12.0632 3.30783 13.8002 4.7525 13.7688 6.56296H14.0625C15.3051 6.56296 16.3125 7.57032 16.3125 8.81296C16.3125 10.0556 15.3051 11.063 14.0625 11.063H4.34546C2.87765 11.063 1.6875 9.87281 1.6875 8.405ZM2.8125 8.405C2.8125 9.25149 3.49897 9.93796 4.34546 9.93796H14.0625C14.6838 9.93796 15.1875 9.43428 15.1875 8.81296C15.1875 8.19164 14.6838 7.68796 14.0625 7.68796H12.3882L12.5823 6.97751C12.9414 5.66068 11.6801 4.47921 10.3894 4.92307L9.42334 5.25486L9.2981 4.62278C8.79182 2.07346 5.0188 2.53009 5.13501 5.12668L5.21338 6.87278H4.34546C3.49905 6.87278 2.81264 7.55863 2.8125 8.405Z"
        fill={color}
      />
      <path
        d="M4.625 6.31005H4.34521C3.18806 6.31005 2.25 7.24811 2.25 8.40526C2.25 9.56241 3.18806 10.5005 4.34521 10.5005H14.0625C14.9945 10.5005 15.75 9.74494 15.75 8.81296C15.75 7.88098 14.9945 7.12546 14.0625 7.12546H13.125C13.603 5.37287 11.9246 3.80012 10.2067 4.39087L9.85 4.51354C9.2086 1.2819 4.42585 1.86017 4.57315 5.15154L4.625 6.31005Z"
        fill={color}
      />
    </svg>
  );
};

export default IDownload;
